export const pageAnimation = {
  hidden: {
    opacity: 0,
    y: -300,
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.25,
      when: "beforeChildren",
      staggerChildren: 0.25,
    },
  },
  exit: {
    opacity: 0,
    y: 300,
    transition: {
      duration: 0.3,
    },
  },
};

// Transition is inside show.

export const titleAnimation = {
  hidden: {
    y: 250,
  },
  show: {
    y: 0,

    transition: {
      duration: 0.75,
      ease: "easeOut",
    },
  },
};

export const Fade = {
  hidden: {
    opacity: 0,
    transition: {
      duration: 0.5,
    },
  },
  show: {
    opacity: 1,
    transition: {
      duration: 1.1,
      ease: "easeOut",
    },
  },
};

export const FadeLine = {
  hidden: {
    opacity: 0,
    width: "20%",
    transition: {
      duration: 0.8,
    },
  },
  show: {
    opacity: 1,
    width: "70%",
    transition: {
      duration: 1.5,
      ease: "easeOut",
    },
  },
};

export const imageAnimation = {
  hidden: {
    scale: 1.3,
    opacity: 0,
    transition: {
      duration: 0.1,
    },
  },

  show: {
    scale: 1,
    opacity: 1,
    transition: {
      duration: 0.8,
      ease: "easeOut",
    },
  },
};

export const WaveAnimation = {
  hidden: {
    pathLength: 0,
    pathOffset: 1,
  },
  show: {
    pathLength: 1,
    pathOffset: 0,
    transition: {
      duration: 1.6,
    },
  },
};

export const lineAnimation = {
  hidden: {
    width: "0%",
  },
  show: {
    width: "100%",
    transition: {
      duration: 1,
    },
  },
};

export const PageColorSlider = {
  hidden: { x: "-130%", skew: "45deg" },
  show: {
    x: "100%",
    skew: "0deg",
    transition: {
      ease: "easeOut",
      duration: 0.8,
    },
  },
};

export const Scale = {
  hidden: {
    scale: 0.5,
  },
  show: {
    scale: 1,
    transition: {
      duration: 0.4,
    },
  },
};

// Doesn't stagger.
export const sliderContainer = {
  hidden: {
    opacity: 1,
  },
  show: {
    opacity: 1,
    transition: {
      when: "beforeChildren",
      staggerChildren: 0.15,
      ease: "easeOut",
    },
  },
};

export const scrollReveal = {
  hidden: {
    opacity: 0,
    scale: 1.3,
    transition: {
      duration: 0.4,
    },
  },
  show: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.6,
    },
  },
};
